module.exports = __webpack_public_path__ + "static/media/ToyotaType-Light.6f5971b2.otf";